module.exports = __webpack_public_path__ + "static/media/ocs.f5b7737c.png";